import React from "react";
import { Button, Message } from "semantic-ui-react";
import { Modal } from "../../../components";

interface Props {
  documentId: number
  isOpen: boolean
  onClose: () => void
  lastOverviewUrl: string
}

const DiscardModal = (props: Props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const onClick = async (e) => {
    e?.preventDefault();
    setIsLoading(true);

    try {
      await window.CoreApi.ESign.ChangeESignToDiscardedStage(props.documentId);
      window.location.href = props.lastOverviewUrl;
    } catch {
      window.displayGenericModalWithHtml(RESX.ExceptionMessage.ThereIsAProblem, RESX.ExceptionMessage.ThereWasAnError, "tiny");
      setIsLoading(false);
    }
  };
  return <Modal
    isOpen={props.isOpen}
    handleClose={props.onClose}
    width="tiny"
    title={RESX.GeneralWarnings.Warning}
  >
    <div className="grow1">
      <Message color="red">
        {RESX.GeneralWarnings.AreYouSure}
        <br /><br />
        {RESX.ESign.DiscardWarning}
        <br /><br />
        {RESX.ESign.DiscardAccessibleWarning}
      </Message>
    </div>

    <div className="flex justify-end margin-top-bigger">
      <Button loading={isLoading} disabled={isLoading} color="blue" onClick={onClick}>
        {RESX.Buttons.btnDiscard}
      </Button>
    </div>
  </Modal>;
};

export default DiscardModal;